<template>
    <div class="visualizador-wrapper ayuda-scope">

        <div class="canvas-principal shadow-xl">

            <button class="glass-btn btn-top-right" title="Ver a pantalla completa"
                @click="mostrarModalFullscreen = true">
                <feather type="maximize" class="icon-sm"></feather>
            </button>

            <button v-if="items.length > 1" class="nav-arrow-float left" @click="anterior" title="Anterior">
                <feather type="chevron-left"></feather>
            </button>

            <button v-if="items.length > 1" class="nav-arrow-float right" @click="siguiente" title="Siguiente">
                <feather type="chevron-right"></feather>
            </button>

            <div class="image-viewport">
                <transition :name="transitionName" mode="out-in">
                    <img :key="indiceActivo" :src="items[indiceActivo].url" class="main-img" alt="imagen del carrusel"/>
                </transition>
            </div>
        </div>

        <div class="footer-container">
            <div class="text-content mb-4" v-if="items[indiceActivo].nombre || items[indiceActivo].descripcion">
                <h4 class="title-step" v-if="items[indiceActivo].nombre">{{ items[indiceActivo].nombre }}</h4>
                <p class="desc-step"
                    v-if="items[indiceActivo].descripcion && items[indiceActivo].descripcion.trim() !== ''">
                    {{ items[indiceActivo].descripcion }}
                </p>
            </div>

            <div class="control-bar-pro">
                <template v-if="items.length > 1">
                    <v-btn text rounded class="action-btn" @click="anterior">
                        <feather type="arrow-left" class="mr-2"></feather> <span
                            class="d-none d-sm-inline">Anterior</span>
                    </v-btn>
                </template>

                <div class="pagination-hub">
                    <span class="counter-badge">{{ indiceActivo + 1 }} de {{ items.length }}</span>
                    <div class="dots-row">
                        <div v-for="(_, i) in items" :key="i" class="dot-pro"
                            :class="{ 'is-active': i === indiceActivo }" @click="indiceActivo = i"></div>
                    </div>
                </div>

                <template v-if="items.length > 1">
                    <v-btn text rounded class="action-btn" @click="siguiente">
                        <span class="d-none d-sm-inline">Siguiente</span>
                        <feather type="arrow-right" class="ml-2"></feather>
                    </v-btn>
                </template>

            </div>
        </div>

        <v-dialog v-model="mostrarModalFullscreen" fullscreen hide-overlay transition="dialog-bottom-transition"
            class="fullscreen-dialog-aciqui">
            <div class="fullscreen-viewer-content">
                <div class="viewer-toolbar">
                    <div class="toolbar-info">
                        <span class="img-title-fs">{{ items[indiceActivo].nombre || 'Visualizador' }}</span>
                        <span class="img-counter-fs">{{ indiceActivo + 1 }} / {{ items.length }}</span>
                    </div>
                    <button class="close-fs-btn" @click="mostrarModalFullscreen = false">
                        <feather type="x"></feather>
                    </button>
                </div>

                <div class="viewer-stage">
                    <template v-if="items.length > 1">
                        <button class="nav-arrow-fs left" @click="anterior">
                            <feather type="chevron-left"></feather>
                        </button>
                    </template>

                    <img :src="items[indiceActivo].url" :alt="items[indiceActivo].nombre" class="img-fullscreen" />

                    <template v-if="items.length > 1">
                        <button class="nav-arrow-fs right" @click="siguiente">
                            <feather type="chevron-right"></feather>
                        </button>
                    </template>
                </div>
            </div>
        </v-dialog>

    </div>
</template>

<script>
export default {
    props: {
        items: { type: Array, required: true }
    },
    data() {
        return {
            indiceActivo: 0,
            transitionName: 'slide-right',
            mostrarModalFullscreen: false,
        }
    },
    methods: {
        siguiente() {
            this.transitionName = 'slide-next';
            // LÓGICA DE BUCLE: Si es el último, va al primero (0)
            this.indiceActivo = (this.indiceActivo + 1) % this.items.length;
        },
        anterior() {
            this.transitionName = 'slide-prev';
            // LÓGICA DE BUCLE: Si es el primero, va al último
            this.indiceActivo = (this.indiceActivo - 1 + this.items.length) % this.items.length;
        }
    },
    mounted() {
        const handleEsc = (e) => {
            if (e.key === 'Escape' && this.mostrarModalFullscreen) {
                this.mostrarModalFullscreen = false;
            }
        };
        window.addEventListener('keydown', handleEsc);
        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('keydown', handleEsc);
        });
    }
}
</script>

<style scoped>
.visualizador-wrapper {
    max-width: 950px;
    margin: 8px auto;
    font-family: 'Lexend', sans-serif;
}

/* Canvas de la imagen con diseño Apple-style */
.canvas-principal {
    position: relative;
    background-color: var(--sidebar-bg) !important;
    border-radius: 20px;
    padding: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgba(0, 0, 0, 0.08);
    min-height: 400px;
    overflow: hidden;
    transition: background-color 0.3s ease;
}

.image-viewport {
    width: 100%;
    display: flex;
    justify-content: center;
}

.main-img {
    max-width: 100%;
    max-height: 550px;
    object-fit: contain;
    border-radius: 8px;
    /* Efecto de sombra suave a la imagen interna si quieres */
}

/* Botones con Glassmorphism */
.glass-btn,
.nav-arrow-float {
    background: rgba(var(--v-text-base-rgb, 128, 128, 128), 0.05);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 5;
}

/* Estilos específicos para modo oscuro si necesitas forzar algo más agresivo */
/* (Por lo general, con las variables de arriba es suficiente) */
.ayuda-scope.theme--dark .canvas-principal {
    background-color: #1e1e2d !important;
    /* Un gris muy oscuro si prefieres fijo */
    border-color: #323246 !important;
}

.ayuda-scope.theme--dark .glass-btn,
.ayuda-scope.theme--dark .nav-arrow-float {
    background: rgba(0, 0, 0, 0.3);
    color: #fff;
}

.btn-top-right {
    position: absolute;
    top: 20px;
    right: 20px;
    padding: 8px;
    border-radius: 12px;
}

.nav-arrow-float {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    padding: 12px;
    border-radius: 50%;
    color: var(--primary-color);
}

.nav-arrow-float:hover {
    background: var(--primary-color);
    color: white;
    transform: translateY(-50%) scale(1.1);
}

.left {
    left: 20px;
}

.right {
    right: 20px;
}

/* Pie de controles */
.control-bar-pro {
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    background: var(--sidebar-bg);
    border: 1px solid var(--border-color);
    border-radius: 100px;
    /* Estilo píldora */
    padding: 8px 20px;
}

.action-btn {
    font-weight: 700 !important;
    color: var(--text-color) !important;
    text-transform: none !important;
}

.pagination-hub {
    text-align: center;
}

.counter-badge {
    display: block;
    font-size: 0.8rem;
    font-weight: 700;
    color: var(--text-color);
    margin-bottom: 4px;
}

.dots-row {
    display: flex;
    gap: 6px;
    justify-content: center;
}

.dot-pro {
    width: 6px;
    height: 6px;
    background: #cbd5e0;
    border-radius: 50%;
    transition: all 0.4s ease;
    cursor: pointer;
}

.dot-pro.is-active {
    background: var(--primary-color);
    width: 20px;
    /* Dot alargado tipo iOS */
    border-radius: 10px;
}

/* Textos */
.title-step {
    font-size: 1.3rem;
    font-weight: 800;
    color: var(--primary-color);
}

.desc-step {
    font-size: 1rem;
    color: var(--text-color);
    line-height: 1.6;
}

/* Transiciones de deslizamiento */
.slide-next-enter {
    opacity: 0;
    transform: translateX(30px);
}

.slide-next-leave-to {
    opacity: 0;
    transform: translateX(-30px);
}

.slide-prev-enter {
    opacity: 0;
    transform: translateX(-30px);
}

.slide-prev-leave-to {
    opacity: 0;
    transform: translateX(30px);
}

.slide-next-enter-active,
.slide-next-leave-active,
.slide-prev-enter-active,
.slide-prev-leave-active {
    transition: all 0.4s ease;
}

.icon-sm {
    width: 18px;
    height: 18px;
}

.footer-container {
    margin-top: 12px;
}

/* ============================================================
   ESTILOS ESPECÍFICOS PARA EL MODAL FULLSCREEN (LIGHTBOX)
   ============================================================ */
.fullscreen-viewer-content {
    width: 100vw;
    height: 100vh;
    /* Fondo muy oscuro para resaltar la imagen, adaptable a Dark Mode */
    background-color: rgba(0, 0, 0, 0.95);
    color: white;
    display: flex;
    flex-direction: column;
    font-family: 'Lexend', sans-serif;
    z-index: 9999;
}

/* Barra de herramientas superior */
.viewer-toolbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px 25px;
    background: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(5px);
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.toolbar-info {
    display: flex;
    flex-direction: column;
}

.img-title-fs {
    font-weight: 700;
    font-size: 1.1rem;
    color: #fff;
}

.img-counter-fs {
    font-size: 0.8rem;
    opacity: 0.7;
    color: #fff;
}

.close-fs-btn {
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    padding: 10px;
    border-radius: 50%;
    cursor: pointer;
    transition: background 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-fs-btn:hover {
    background: rgba(255, 0, 0, 0.5);
    /* Rojo suave al hover */
}

/* Escenario central de la imagen */
.viewer-stage {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 20px;
    overflow: hidden;
}

.img-fullscreen {
    max-width: 90%;
    max-height: 85vh;
    /* Ocupa casi todo el alto visual */
    object-fit: contain;
    /* No deformar */
    box-shadow: 0 10px 50px rgba(0, 0, 0, 0.5);
    border-radius: 4px;
}

/* Flechas de navegación del modal (grandes y claras) */
.nav-arrow-fs {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    background: rgba(255, 255, 255, 0.1);
    border: none;
    color: white;
    padding: 20px;
    border-radius: 50%;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;
}

.nav-arrow-fs:hover {
    background: rgba(var(--v-primary-base-rgb), 0.8);
    /* Azul ACIQUI al hover */
    transform: translateY(-50%) scale(1.1);
}

.nav-arrow-fs.left {
    left: 30px;
}

.nav-arrow-fs.right {
    right: 30px;
}

/* Feather Icons más grandes en el modal */
.nav-arrow-fs .feather {
    width: 30px;
    height: 30px;
}

@media (max-width: 600px) {
    .canvas-principal {
        min-height: 300px;
        padding: 10px;
    }

    .nav-arrow-float {
        display: none;
    }

    /* En móvil se usan los botones de abajo */
    .control-bar-pro {
        border-radius: 15px;
    }

    .nav-arrow-fs {
        padding: 10px;
    }

    .nav-arrow-fs .feather {
        width: 20px;
        height: 20px;
    }

    .nav-arrow-fs.left {
        left: 10px;
    }

    .nav-arrow-fs.right {
        right: 10px;
    }

    .img-fullscreen {
        max-width: 95%;
    }

    .viewer-toolbar {
        padding: 10px 15px;
    }
}
</style>